module.exports = __webpack_public_path__ + "img/croydon-cgl-logo.2cd8a9e1.png";